import { getIdToken } from '../utils/keycloak';
import { getBackendUrl } from '../utils/utils';
import { trackEvent } from '../utils/analytics';
import { FeedbackSubmissionData } from '../types/feedback';

export class FeedbackSubmissionService {
  async submitFeedback(data: FeedbackSubmissionData): Promise<void> {
    const token = await getIdToken();

    const response = await fetch(getBackendUrl('/app-feedback'), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      },
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      throw new Error(`Failed to submit feedback: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    console.log('Feedback submitted successfully:', result);

    // Track feedback submission in Google Analytics
    trackEvent('Feedback', 'Submit', data.type);
  }

  async handleSubmissionWithNotification(
    data: FeedbackSubmissionData,
    onScreenshotUpload?: () => void,
    onSuccess?: () => void,
    onError?: (message: string) => void
  ): Promise<void> {
    try {
      // Notify user if screenshot will be uploaded
      if (data.feedback_metadata.screenshot && onScreenshotUpload) {
        onScreenshotUpload();
      }

      await this.submitFeedback(data);

      if (onSuccess) {
        onSuccess();
      }
    } catch (error) {
      console.error('Failed to submit feedback:', error);
      if (onError) {
        onError('Failed to submit feedback. Please try again.');
      }
    }
  }
}